import { combineReducers } from 'redux';
import authoringContentStore from './authoringContentStore';
import authStore from './authStore';

const reducers = combineReducers({
    discussion: authoringContentStore,
    authStore
});

export default reducers;